export enum Resource {
  UserInfo = 'UserInfo',
  UserInfoAsUser = 'UserInfoAsUser',
  UserInfoAsOrg = 'UserInfoAsOrg',
  OAuthCredential = 'OAuthCredentials',
  ToolConfig = 'ToolConfig',

  // Stripe subscription object
  // Can be get from `response.body.subscription.rawData` of `GET /subscriptions/status`
  Subscription = 'Subscription',
}
